<template>
  <div>
    <b-modal
      id="filter-log-aktivitas"
      ok-only
      centered
      size="md"
      content-class="shadow"
      hide-footer
    >
      <template #modal-title>
        <div style="font-size:24px; font-weight:600;">Filter</div>
      </template>
      <div>
        <b-form-row>
          <b-col>
            <b-row class="d-flex align-items-center mb-2">
              <b-col sm="5"><p style="font-weight:600; margin:0px;">Tanggal Mulai</p></b-col>:
              <b-col sm="6">
                <b-form-datepicker v-model="filter.startDate" locale="id-ID" placeholder="Pilih tanggal" />
              </b-col>
            </b-row>
            <b-row class="d-flex align-items-center mb-2">
              <b-col sm="5"><p style="font-weight:600; margin:0px;">Tanggal Akhir</p></b-col>:
              <b-col sm="6">
                <b-form-datepicker v-model="filter.endDate" locale="id-ID" placeholder="Pilih tanggal" />
              </b-col>
            </b-row>
          </b-col>
        </b-form-row>
        <div class="text-center mt-4">
          <b-button variant="outline-primary" class="mr-3" @click="resetFilter">Reset</b-button>
          <b-button variant="primary" @click="applyFilter">Terapkan</b-button>
        </div>
      </div>
    </b-modal>

    <b-row>
      <b-col cols="12">
        <b-row>
          <b-col cols="11">
            <div
              class="d-flex justify-content-between align-items-center shadow p-1 pr-3"
              style="background:white; border-radius:10px;"
            >
              <input
                type="text"
                class="form-control border-0"
                v-model="search"
                v-on:keyup.enter="fetchData"
                placeholder="Cari nama, entitas, atau kata kunci..."
              />
              <b-button size="sm" style="width:80px; margin-right:10px;" variant="primary" @click="fetchData">
                <v-icon style="color:white;" small>mdi-magnify</v-icon> Cari
              </b-button>
            </div>
          </b-col>
          <b-col cols="1" class="d-flex align-items-center p-0">
            <b-button size="sm" variant="primary" @click="showFilter">
              <v-icon style="color:white;" small>mdi-filter</v-icon> Filter
            </b-button>
          </b-col>
        </b-row>
      </b-col>
    </b-row>

    <b-row class="mt-5">
      <b-col class="d-flex align-items-center justify-content-between">
        <span style="font-size:16px; font-weight:bold;">Log Aktivitas Akses Ormas Badan Hukum</span>
      </b-col>
    </b-row>

    <div class="table-responsive mt-4" style="border-radius:15px;">
      <table
        class="table table-head-custom table-vertical-center table-head-bg table-bordered"
        style="font-size:14px !important;"
      >
        <thead>
          <tr class="text-left">
            <th style="width:50px;" class="text-capitalize">No.</th>
            <th style="min-width:140px;" class="text-capitalize">Usertype</th>
            <th style="min-width:160px;" class="text-capitalize">Nama Pengguna</th>
            <th style="min-width:120px;" class="text-capitalize">Aktivitas</th>
            <th style="min-width:320px;" class="text-capitalize">Data</th>
            <th style="min-width:160px;" class="text-capitalize">Tanggal dan Waktu Akses</th>
          </tr>
        </thead>
        <tbody style="background:#FFFFFF;">
          <template v-if="loading">
            <tr><td colspan="6" class="text-center py-4">Memuat...</td></tr>
          </template>
          <template v-else-if="rows.length === 0">
            <tr><td colspan="6" class="text-center py-4">Tidak ada data log aktivitas</td></tr>
          </template>
          <template v-else>
            <tr v-for="(item, i) in rows" :key="item._id || i">
              <td>
                <span class="text-dark-75 font-weight-bolder d-block font-size-lg">
                  {{ (i + 1) + ((currentPage - 1) * perPage) }}
                </span>
              </td>
              <td class="text-left">
                <span class="text-dark-75 font-weight-bolder d-block font-size-lg">
                  {{ item.role_name || '-' }}
                </span>
              </td>
              <td class="text-left">
                <span class="text-dark-75 font-weight-bolder d-block font-size-lg">
                  {{ item.nama_lengkap || '-' }}
                </span>
              </td>
              <td class="text-left">
                <span class="text-dark-75 font-weight-bolder d-block font-size-lg">
                  {{ actionLabel(item) }}
                </span>
              </td>
              <td class="text-left">
                <span
                  class="text-dark-75 font-weight-bolder d-block font-size-lg"
                  style="white-space:normal; word-break:break-word;"
                >
                  {{ dataLabel(item) }}
                </span>
              </td>
              <td class="text-left">
                <span class="text-dark-75 font-weight-bolder d-block font-size-lg">
                  {{ formatDate(item.activity_date) }}
                </span>
              </td>
            </tr>
          </template>
        </tbody>
      </table>
    </div>

    <b-row>
      <b-col class="d-flex justify-content-end">
        <b-pagination
          v-model="currentPage"
          :total-rows="totalRows"
          :per-page="perPage"
          aria-controls="log-aktivitas-table"
        ></b-pagination>
      </b-col>
    </b-row>
  </div>
</template>

<script>
export default {
  name: "LogAktivitas",
  data() {
    return {
      currentPage: 1,
      perPage: 20,
      totalRows: 0,
      search: '',
      filter: { startDate: null, endDate: null },
      rows: [],
      loading: false,
      typingTimeout: null
    };
  },
  mounted() {
    this.fetchData();
  },
  watch: {
    currentPage() {
      this.fetchData();
    },
    search() {
      if (this.typingTimeout) clearTimeout(this.typingTimeout);
      this.typingTimeout = setTimeout(() => {
        this.currentPage = 1;
        this.fetchData();
      }, 500);
    }
  },
  methods: {
    showFilter() {
      this.$bvModal.show('filter-log-aktivitas');
    },
    applyFilter() {
      this.currentPage = 1;
      this.$bvModal.hide('filter-log-aktivitas');
      this.fetchData();
    },
    resetFilter() {
      this.filter.startDate = null;
      this.filter.endDate = null;
    },
    queryParams() {
      const params = {
        search: this.search,
        skip: (this.currentPage - 1) * this.perPage,
        limit: this.perPage
      };
      // startDate & endDate independen: dukung rentang awal-saja / akhir-saja.
      if (this.filter.startDate) {
        params.startDate = new Date(this.filter.startDate).toISOString();
      }
      if (this.filter.endDate) {
        // tutup endDate ke akhir hari
        params.endDate = new Date(this.filter.endDate + 'T23:59:59').toISOString();
      }
      return params;
    },
    fetchData() {
      this.loading = true;
      const params = this.queryParams();
      this.$store
        .dispatch('bakumActivityCount', params)
        .then(res => { this.totalRows = (res && res.data && res.data.count) || 0; })
        .catch(() => { this.totalRows = 0; });
      this.$store
        .dispatch('bakumActivityList', params)
        .then(res => {
          this.rows = (res && res.data) || [];
          this.loading = false;
        })
        .catch(() => {
          this.rows = [];
          this.loading = false;
        });
    },
    // Verb pendek kolom Aktivitas. Utamakan field tersimpan; turunkan dari kalimat untuk log lama.
    actionLabel(item) {
      if (item && item.action_label) return item.action_label;
      const text = (item && item.activity ? item.activity : '').toLowerCase();
      if (text.indexOf('mencari') !== -1) return 'Pencarian';
      if (text.indexOf('unduh') !== -1) return 'Mengunduh';
      return 'Membuka';
    },
    // Isi kolom Data. Utamakan field tersimpan; fallback ke target_keyword untuk log lama.
    dataLabel(item) {
      if (item && item.data_label) return item.data_label;
      if (item && item.target_keyword) return item.target_keyword;
      return '-';
    },
    formatDate(iso) {
      if (!iso) return '-';
      try {
        const d = new Date(iso);
        // Format sesuai desain: "07/07/26, 22:54"
        const date = d.toLocaleDateString('id-ID', { day: '2-digit', month: '2-digit', year: '2-digit' });
        const time = d.toLocaleTimeString('id-ID', { hour: '2-digit', minute: '2-digit', hour12: false });
        return date + ', ' + time;
      } catch (_e) {
        return iso;
      }
    }
  }
};
</script>
